<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('benefitCreate') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId" >
                        {{ assetTypeName || $t('assetType') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ $t('benefitCreate') }}</li>
            </ol>
        </nav>
        <div class="row mb-4">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
              <div class="mb-3 col-md-8">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description">
            </div>
        </div>
        <div class="mb-4">
            <h4>{{ $t('benefitAttributes') }}</h4>
            <table class="table ">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('name') }}</th>
                        <th scope="col">{{ $t('weight') }}</th>
                        <th scope="col">{{ $t('biggerMoreBenefit') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(benefitAttribute, i) in data.benefitAttributes" class="align-middle"  :key="i" >
                        <th scope="row"><i class="fa fa-remove" @click="removeBenefitAttribute(i)"></i></th>
                        <td>
                            <!-- <input v-model="benefitAttribute.name" type="text" class="form-control" :id="'name_' + i"> -->
                            <select class="form-select" v-model="benefitAttribute.name">
                                <option disabled>{{ $t('select') }}</option>
                                <template v-if="datasetHeaders.length > 0" >
                                    <option v-for="(datasetHeader, i) in datasetHeaders" :key="i"  v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                                </template>
                            </select>
                        </td>
                        <td>
                            <input v-model="benefitAttribute.weight" type="number" class="form-control" :id="'weight_' + i">
                        </td>
                        <td>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="benefitAttribute.biggerMoreBenefit" :id="'biggerMoreBenefit_' + i" checked>
                            
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-secondary w-25 mx-auto d-block"  @click="addBenefitAttribute"><i class="fa-solid fa-plus"></i></button>
        </div>
        <div class="d-grid gap-2 d-md-flex ">
            <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('create') }}</button>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })">{{ $t('back') }}</button>
        </div>
    </div>
</template>

<script>
import BenefitApi from "../../api/server/benefit";
import DatasetApi from "../../api/server/dataset";
import AssetTypeApi from "../../api/server/assetType";
import ModelingApi from "../../api/server/modeling";

export default {
    name: "benefitCreate",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.pending = true;

            var assetType = await AssetTypeApi.assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;


            var dataset = await DatasetApi.datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];

            this.pending = false;
        },
        async onSubmit() {
            if(this.data.name.length > 0) {
                this.data.assetTypeId = this.$route.params.assetTypeId;
                await BenefitApi.benefitCreate(this.$route.params.id, this.data);
                this.$router.go(-1);
            } else {
                this.showEmptyNameError();
            }
        },
        addBenefitAttribute() {
            this.data.benefitAttributes.push({ name: "", biggerMoreBenefit: false, weight: 0 })
        },
        removeBenefitAttribute(rowIndex) {
            this.data.benefitAttributes.splice(rowIndex, 1);
        }
    },
    data() {
        return {
            datasetHeaders: [],
            data: {
                name: "",
                benefitAttributes: [
                    {
                        name: "",
                        weight: 0,
                        biggerMoreBenefit: false
                    }
                ],
                id: 0
            },
            modelingName: null,
            assetTypeName: null,
            pending: true
        }
    },
    notifications: {
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    }
};
</script>